export const getters = {
    list: state => state.list,
    lastId: state => state.lastId,
    inventory: state => state.inventory,
    columns: state => state.columns,
    model: state => state.model,
    filter: state => state.filter,
    pagination: state => state.pagination,
    sort: state => state.sort,
    rules: state => state.rules,
    activeCode: state => state.activeCode,
    patientName: state => state.patientName
};
